import { useContext, useMemo } from "react";
import { Lookup } from "src/common/Common.Type";
import { useGet } from "./useGet";
import { useDropdownApiTypes } from "./Types/useDropDownApi.types";
import { Context } from "src/context";

export const useDropdownApi = ({ ApiMethod, sourceId, depArr, optionList }: useDropdownApiTypes) => {
    const { customSearchData } = useContext(Context);
    const searchData: Record<string, any> = customSearchData;

    const apiParams = useMemo(() => {
        let params: any = {};
        if (!!(ApiMethod && sourceId && searchData[sourceId])) params[sourceId] = searchData[sourceId]

        if (depArr && ApiMethod) {
            depArr.forEach((key) => params[key] = searchData[key]?.join(","));
        }
        return params
    }, [sourceId, searchData, ApiMethod, depArr]);

    const isNotValid = useMemo(() => {
        if (!ApiMethod) return true;

        if (sourceId && !searchData[sourceId]) return true;

        if (sourceId && !searchData[sourceId].length) return true;

        if (depArr?.length && apiParams === null) return true;

        return false;
    }, [ApiMethod, sourceId, searchData, depArr, apiParams]);


    const { data: apiOptions, isPending } = useGet<Lookup[]>({
        API: ApiMethod,
        isNotValid,
        params: [apiParams && sourceId ? apiParams[sourceId] : undefined],
        depArr: [apiParams && sourceId ? apiParams[sourceId] : undefined],
        defaultValue: [],
        needSpinner: false
    });

    const options = useMemo(() => {
        if (optionList) return optionList;
        return apiOptions || [];
    }, [optionList, apiOptions]);

    return { options, isPending, apiParams }
}